<template>
    <div class="mt-2">
        <p class="text-sm text-tertiary">
            <slot />
        </p>
    </div>
</template>
